// extracted by mini-css-extract-plugin
export default {"list":"Q9ubM","listItem":"gmqel","check":"ARwm2","text":"zl0Pq","skeleton-progress":"Ortre"};